export default __webpack_public_path__ + "static/logotipo-bert-cd96d16c9ce6860a2d89bd3099de990f.svg";